import { useOrganisationRecord } from "@/app/Organisations/Hooks/useOrganisationRecord";
import { InvoiceTable } from "@/app/Invoices/Components/InvoiceTable";

export function OrganisationInvoicesScreen() {
  const record = useOrganisationRecord();

  return (
    <div className="py-6">
      <InvoiceTable
        id="organisation-invoices"
        queryVariables={{
          managedById: record.id,
          // Every invoice the organisation is on the hook for, not just those
          // for whichever supplier is selected globally.
          supplierId: undefined,
        }}
      />
    </div>
  );
}
